import { makeStyles } from '@material-ui/core/styles';
import signinIcon from '../../assets/SignIn/SignIn.svg';

export const useStyles = makeStyles((theme) => ({
  rootBg: {
    width: '100%',
    minHeight: '100vh',
    backgroundColor: '#ccc',
    display: 'flex',
    justifyContent: 'center',
    backgroundImage: `url(${signinIcon})`,
    backgroundPosition: "bottom left",
    backgroundRepeat: "no-repeat",
    backgroundSize: 'contain',
  },
  root: {
    width: "100%",
    maxWidth: "120em",
    padding: "2.3em 1.5em 9em",
    margin: '0 auto',
    [theme.breakpoints.down('md')]: {
      padding: "2.3em 1.5em 5em",
    },
  },

  loaderContainer: {
    width: '100%',
    height: '100%',
    minHeight: '60vh',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },

  container: {
    width: '100%',
    marginTop: 25,
  },

  link: {
    color: "#25ABC7",
    fontFamily: "Montserrat",
    fontSize: "16px",
    fontWeight: "600",
    marginTop: 14,
  },
  btn:{
       broder:'1px solid #EDB36A',
       background: 'white',
       width: '230px',
       float: 'right',
       marginTop: '-30px',
       cursor:'pointer',
       '&:hover':{
        background:'white'
       },
       [theme.breakpoints.down('sm')]: {
        fontSize: '10px',
        width:'160px'
      }
  },

  disabledLink: {
    color: "#7B8390",
    fontFamily: "Montserrat",
    fontSize: "16px",
    fontWeight: "bold",
    textDecoration: 'none',
  },

  activeLink: {
    color: theme.palette.primary.main,
    fontFamily: "Montserrat",
    fontSize: "16px",
    fontWeight: "600",
    textDecoration: 'none',
  },

  responsiveIframe: {
    width: '100%',
    height: '800px',
    border: 'none'
  },

  pt10: {
    paddingTop: '10px'
  }


}));